<mat-toolbar>
<button
      class="ms-1"
      mat-stroked-button
      (click)="onSubmit()">
      Refresh
    </button>
    <app-material-auto-complete
      class="ms-1"
      [(ngModel)]="_type"
      [items]="typeList"
      [formatter]="typeFormatter"
      (ngModelChange)="type = $event"
      name="type"
      id="type">
    </app-material-auto-complete>
    <app-material-auto-complete
      class="ms-1"
      id="SofItem2"
      [formatter]="lookupItemListFormatter"
      [(ngModel)]="extraSofEntry2"
      [items]="filterSofItems"
      name="SofItem2">
    </app-material-auto-complete>
    <app-material-auto-complete
      class="ms-1"
      id="SofItem1"
      [formatter]="lookupItemListFormatter"
      [(ngModel)]="extraSofEntry"
      [items]="filterSofItems"
      name="SofItem1">
    </app-material-auto-complete>

    <app-material-date-range
      class="ms-1"
      id="selectedDateRangeGregorian"
      [(dateRange)]="dateRange">
    </app-material-date-range>
</mat-toolbar>